// Packages:
import React, { memo } from "react";
import { useSelector } from "react-redux";


// Styles:
import { Body, Description, Field, NodeLabel, NodeWrapper, StyledHandle } from "../styles";
import BaseNode from "../BaseNode";
import { config } from "./config";
import useNodeStyles from "../../../../hooks/useNodeStyles";


// Functions:
const GoogleSheetsNode = ({ data }) => {
  // Constants:
  const { id, sheet, operation, label } = data;

  // Ref:

  // State:
  const studio = useSelector((state) => state.studio);
  const isSelected = useSelector(
    (state) => state.studio.selectedNode?.id === id
  );
  const {computedLabelStyle,computedBodyStyle,computedWrapperStyle}=useNodeStyles({isSelected,config})


    const changeName = (i) => {
      switch (i) {
        case 'create':
          return "CREATE NEW ENTRY";
        case 'delete':
          return "DELETE ENTRY FROM SHEET";
        case 'read':
          return "READ FROM SHEET";
        case 'update':
          return "UPDATE ENTRY";
      }
    };

  // Return:
  return (
    <BaseNode data={data} config={config}>
      <NodeWrapper style={computedWrapperStyle} backgroundColor={'#FEFFFE'} borderColor={'#188038'}>
      {config.handleStyles.map((handle, index) => (
        <StyledHandle
            key={index}
            id={handle.properties.id}
            type={handle.properties.type}
            position={handle.properties.position}
            style={handle.style}
        />
        ))}
        <NodeLabel htmlFor="text" style={computedLabelStyle}>
          {label}
        </NodeLabel>
        <Body style={computedBodyStyle}>
          <Description>
            <Field isActive={studio.selectedNode?.id === id} activeColor={'#0D451E'} inActiveColor={'#188038'}>
              {!operation ? (
                <span style={{ fontStyle: "italic", fontWeight: 400 }}>
                  Functionality
                </span>
              ) : (
                changeName(operation)
              )}
            </Field>
          </Description>
          <Description>
            <Field isActive={studio.selectedNode?.id === id}>
              {!sheet ? (
                <span style={{ fontStyle: "italic", fontWeight: 400 }}>
                  Enter a sheet name...
                </span>
              ) : (
                sheet
              )}
            </Field>
          </Description>
        </Body>
      </NodeWrapper>
    </BaseNode>
  );
};

// Exports:
export default memo(GoogleSheetsNode);